export enum storeId {
  MAIN = 'main',
  BOOKING_SELECTIONS = 'bookingSelections',
  CART = 'cart',
  CHECKOUT = 'checkout',
  BOOKING_COMMERCE = 'bookingCommerce',
  CONTENT = 'content',
  DEPLOY_VERSION = 'deployVersion'
}
